import React from 'react';
import ExpenseContractRequestWorkspace from './ExpenseContractRequestWorkspace';

/** 계약의뢰등록 — 품의 승인 후 계약담당에게 의 */
export default function ExpenseContractRequestRegister() {
  return <ExpenseContractRequestWorkspace screenMode="register" />;
}
